import VARIANT from '../textVariant';
import R from '../../../core-res/R';
import { StyleSheet } from 'react-native';
/**
 * Helper function to get default style based on token
 * @param {String} variant
 */
export default function getDefaultStyle(variant) {
    switch (variant) {
        case VARIANT.HERO:
            return styles.hero;
        case VARIANT.DISPLAY:
            return styles.display;
        case VARIANT.HEADLINE:
            return styles.headline;
        case VARIANT.TITLE_1:
            return styles.title1;
        case VARIANT.TITLE_2:
            return styles.title2;
        case VARIANT.TITLE_3:
            return styles.title3;
        case VARIANT.UI_LARGE:
            return styles.uiLarge;
        case VARIANT.UI_SMALL:
            return styles.uiSmall;
        case VARIANT.UI_TINY:
            return styles.uiTiny;
        case VARIANT.CAPTION_TINY:
            return styles.captionTiny;
        case VARIANT.CAPTION_MICRO:
            return styles.captionMicro;
        default:
            return styles.uiBaseline;
    }
}
;
const styles = StyleSheet.create({
    hero: R.typography.hero,
    display: R.typography.display,
    headline: R.typography.headline,
    title1: R.typography.title1,
    title2: R.typography.title2,
    title3: R.typography.title3,
    uiLarge: R.typography.uiLarge,
    uiSmall: R.typography.uiSmall,
    uiTiny: R.typography.uiTiny,
    captionTiny: R.typography.captionTiny,
    captionMicro: R.typography.captionMicro,
    uiBaseline: R.typography.uiBaseline,
});
